
import { Component, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";

import { DispatchRequest, MobileFeatures, DispatchType, GuardStatus, Mobile as MobileState, TrackingToggle } from "@/store/mobile/types";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";
import DispatchMixin from "@/mixins/DispatchMixin";
import GuardTourMixin from "@/components/mobile/dispatch/GuardTourMixin";

const Mobile = namespace("mobile");
const Tasks = namespace("tasks");
const GuardTours = namespace("GuardTours");

@Component({
	components: {}
})
export default class FinishContinueButton extends Mixins(DispatchMixin, GuardTourMixin) {
    @Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
    @Mobile.Action finishDispatchRequest: any;
	@Mobile.Action continueTour: ({tourId, stepId, dispatchQueueId}) => void;
    @Mobile.Action addEventRecordForGuard: ({
		eventId,
		eventRecordTypeId,
		details,
		objectId
	}) => void;
    @Mobile.Getter("getCallSign") callSign: "";

    @Mobile.State(state => state.DispatchGuard.manualLocationUpdate) manualLocationUpdate: boolean;
    @Mobile.State(state => state.DispatchGuard.currentTourStepIdentifier) currentTourStepIdentifier: string;
	@Mobile.Action guardArrived: ({dispatchQueueId: number, hasArrived: boolean}) => Promise<void>;

    @GuardTours.Action fetchGuardTour;
	@GuardTours.Getter getGuardTour: (guardTourId: number) => GuardTour;

    @Getter("getFeature") getFeature: (featureName: string[]) => boolean;

    @Emit("finished-dispatch")
	public emitFinishedDispatch(dispatchQueueID: number) {
		this.guardArrived({dispatchQueueId: this.activeDispatchRequest.dispatchQueueID, hasArrived: false});
		return dispatchQueueID;
	}

    private get isMobileCheckInEnabled(): boolean {
		return this.getFeature(["Mobile", "CheckIn"]);
	}

    private async mounted() {
		if (this.isTourType(this.activeDispatchRequest && this.activeDispatchRequest.dispatchType)) {
			await this.fetchGuardTour(this.activeDispatchRequest.guardTourId);
		}
	}

    public async finishDispatch() {
		this.emitFinishedDispatch(this.activeDispatchRequest.dispatchQueueID);

		if (this.isTourType(this.activeDispatchRequest.dispatchType))
		{
			await this.continueTour({
				tourId : this.activeDispatchRequest.guardTourId, 
				stepId : this.activeDispatchRequest.objectId,
				dispatchQueueId: this.activeDispatchRequest.dispatchQueueID
			});
		} else {
			await this.auditGuardHasNotCheckedIn();
			await this.finishDispatchRequest(this.activeDispatchRequest.dispatchQueueID);
		}
	}

    private async auditGuardHasNotCheckedIn(){
        // if feature flag is on and gps is disabled, check the user has checked in
		if (this.isMobileCheckInEnabled && this.manualLocationUpdate && this.activeDispatchRequest.dispatchType == DispatchType.Tour) {

			if (this.currentTourStepIdentifier && this.currentTourStepIdentifier.length > 0) {
				await this.addEventRecordForGuard({ 
					eventId: this.activeDispatchRequest.eventID, 
					details: `Callsign ${this.callSign} has completed without checking in`, 
					objectId: this.activeDispatchRequest.guardID,
					eventRecordTypeId: 152,
				});
			}
		}
    }

	public async getNextTourStep() {
		this.emitFinishedDispatch(this.activeDispatchRequest.dispatchQueueID);
		await this.continueTour({
			tourId : this.activeDispatchRequest.guardTourId, 
			stepId : this.activeDispatchRequest.objectId,
			dispatchQueueId: this.activeDispatchRequest.dispatchQueueID
		});		
	}
}
